<template>
  <p class="solution-header ma-0 subtitle2">
    <span class="solution-header__title" data-testid="solution-title">
      {{
        $t('problem_solving.improve.accordion_item_title', {
          rootCauseNumber: this.getRootCauseNumber(),
        })
      }}
    </span>

    <span
      class="solution-header__status"
      data-testid="solution-status"
      :class="{
        'solution-header__status--completed': this.status === 'completed',
        'solution-header__status--missing': this.isMissingRootCause,
      }"
      >{{ this.getStatus() }}</span
    >
  </p>
</template>

<script>
export default {
  name: 'SolutionHeader',
  props: {
    index: {
      type: Number,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },

  computed: {
    isMissingRootCause() {
      return this.status === 'missing'
    },
  },

  methods: {
    getRootCauseNumber() {
      // Root cause number has a "NN" format, starting in 1. Here we pad the item index with leading zeros. For an element with index = 0 this function will return "01".
      return String(this.index + 1).padStart(2, '0')
    },
    getStatus() {
      switch (this.status) {
        case 'inProgress':
          return this.$t('problem_solving.improve.status_in_progress')
        case 'completed':
          return this.$t('problem_solving.improve.status_completed')
        case 'missing':
          return this.$t('problem_solving.improve.status_missing')
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.solution-header {
  &__title {
    color: $color-blue-grey-darken1;
  }

  &__status {
    &--completed {
      color: $color-green;
    }

    &--missing {
      color: $color-blue-grey-darken1;
    }
  }
}
</style>
